import { render, staticRenderFns } from "./SubscriptionClassesList.vue?vue&type=template&id=9988bd9c"
import script from "./SubscriptionClassesList.vue?vue&type=script&lang=js"
export * from "./SubscriptionClassesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports